import { Box, Stack } from '@atgfr8/atg-ui-tailwind';
import { useParams } from '@solidjs/router';
import {
  fetchCustomerOfficeGroupsCall,
  OfficeItemType,
} from '@store/customers/customerDetails';
import { getProspectAsCustomer } from '@store/prospect';
import { userStore } from '@store/user';
import { isAdmin, isSuperAdmin } from '@utils/utils';
import { createEffect, createSignal, onCleanup } from 'solid-js';

import { NewCustomerHeader, NewCustomerTabPanel } from './components';
import {
  setCreateCustomerStore,
  setupNewCustomerState,
} from './components/NewCustomerTabPanel/NewCustomerTabPanel';
export const [assignOfficeGroup, setAssignOfficeGroup] = createSignal<
  OfficeItemType[]
>([]);

const NewCustomer = () => {
  const param = useParams();

  const fetchOfficeGroups = async (officeId: number) => {
    const resp = await fetchCustomerOfficeGroupsCall(officeId);
    if (resp && resp.isSuccess) {
      resp.value = resp.value.filter(
        (x) => x.name != 'Managers' && x.name != 'Admin',
      );
      if (!isAdmin() && !isSuperAdmin()) {
        resp.value = resp.value.filter((x) => x.name !== 'The Office');
      }
      const assignOfficeGroupRes = resp.value.map((item) => {
        return {
          ...item,
          label: `${item.name as string} (${item.office})`,
          value: item.id,
        };
      });
      setAssignOfficeGroup(assignOfficeGroupRes);
    }
  };

  createEffect(async () => {
    if (Boolean(param.id)) {
      const res = await getProspectAsCustomer(parseInt(param.id as string));
      if (res && res.isSuccess) {
        const newCustomer = {
          ...res.value,
          contacts: res.value.contacts.map((contact) => {
            return {
              ...contact,
              uniqueId: Math.floor(10000 + Math.random() * 90000),
            };
          }),
        };
        setCreateCustomerStore('customer', newCustomer);
        Boolean(res.value.accountManagerOfficeId) &&
          (await fetchOfficeGroups(res.value.accountManagerOfficeId!));
      }
    } else {
      if (userStore.user.officeId) {
        const { id, name, officeId } = userStore.user;
        setupNewCustomerState({
          accountManagerOfficeId: officeId,
          accountManagerName: name,
          accountManagerId: id,
          salesManagerName: name,
          salesManagerId: id,
        });
        await fetchOfficeGroups(officeId);
      }
    }
    updateTabPanelHeight();
  });

  const updateTabPanelHeight = () => {
    const header = document.getElementById('customer-header');
    const tabPanel = document.getElementById('customer-tab-panel');
    if (header && tabPanel) {
      const headerHeight = header.offsetHeight;
      tabPanel.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  };

  onCleanup(() => {
    window.removeEventListener('resize', updateTabPanelHeight);
  });
  return (
    <>
      <Box
        class="flex justify-between items-center bg-white sticky shadow-lg top-0 z-10"
        id="customer-header"
      >
        <NewCustomerHeader />
      </Box>
      <Stack class="bg-[#E1ECF2] overflow-y-auto" id="customer-tab-panel">
        <Box class="m-2 p-2 rounded-md bg-white">
          <NewCustomerTabPanel />
        </Box>
      </Stack>
    </>
  );
};

export default NewCustomer;
